<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" title="Guardar" class="btn btn-outline-success" (click)="guardarInspecciones()"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
            <button [disabled]="!habilitarEdicion" type="button" class="btn btn-outline-success" (click)="onRevisionSolicitanteConfirm()" title="Revisión Solicitante"><i class="fa fa-reply"></i> Revisión Solicitante</button>
            <button [disabled]="!habilitarEdicion" type="button" class="btn btn-outline-success" (click)="onNuevoEquipamiento()" title="Nuevo Equipamiento"><i class="fa fa-plus"></i> Nuevo Equipamiento</button>
            <button [disabled]="!habilitarNuevoSeguimiento" class="btn btn-outline-success" type="button" (click)="onAddSeguimiento()"><i class="icon-seguimiento"></i> Nuevo Seguimiento</button>
            <button *ngIf="allowReasignacion" [disabled]="!habilitarReasignacionPcf" class="btn btn-outline-success" type="button" (click)="onReasignarPcf()">
                <!-- TODO: Este ícono esta pendiente por sustituir -->
                <i class="icon-puntos_inspeccion"></i> Reasignar PCF
            </button>
        </div>
    </nav>

    <app-matricula-precinto-popup (selected)="onAcceptDialogMatriculaPrecinto($event)"></app-matricula-precinto-popup>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Inspecciones {{CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloEstadoSolicitudEx}}" />
                <img *ngIf="IdSubTipoSolicitudEx === tercerPaisConAtestFito || IdSubTipoSolicitudEx === reExpConAtestFito || IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>


        <div class="row">

            <div class="col-md-12">

                <ng-container *ngIf="IdSolicitudEx">
                    <app-alertarechazo [id]="IdSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="row">

                    <div class="col-md-3">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-list"></i> <strong>Equipamiento</strong>
                            </div>
                            <div class="card-body-grid">
                                <!--GRID-->
                                <div class="row">

                                    <div class="col-md-12">

                                        <!--<label class="cabeceraTablaDetalles">Matrí­culas / Nº Contenedor</label>-->
                                        <table class="table table-list table-sm table-0-marginbot">
                                            <!-- table-responsive -->
                                            <thead>
                                                <tr>
                                                    <th class="cabecerasTablaDetalles"></th>
                                                    <th class="cabecerasTablaDetalles">Sel.</th>
                                                    <th class="cabecerasTablaDetalles">Matrículas</th>
                                                    <th class="cabecerasTablaDetalles">Precinto</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr formArrayName="matriculasInsp" *ngFor="let order of getMatriculaControls(); let i = index">
                                                    <td>
                                                        <div *ngIf="habilitarEdicion" class="btn-group">
                                                            <!--editar-->
                                                            <div>
                                                                <button (click)="editEquipamiento(matriculasInsp[i])" type="button" ngbTooltip="Editar"
                                                                        class="btn btn-sm btn-warning">
                                                                    <span class="fa fa-edit"></span>

                                                                </button>
                                                            </div>
                                                            <!--borrar-->
                                                            <div>
                                                                <button (click)="deleteEquipamiento(matriculasInsp[i])" type="button" ngbTooltip="Eliminar"
                                                                        class="btn btn-sm btn-danger">
                                                                    <span class="fa fa-remove"></span>

                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td><p-checkbox [disabled]="!habilitarGuardar" [formControlName]="i" binary="true"></p-checkbox></td>
                                                    <td>{{matriculasInsp[i].Matricula}}</td>
                                                    <td>{{matriculasInsp[i].Precinto}}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div>
                                            <input *ngIf="false" formControlName="validPosicionamiento" [ngClass]="displayFieldCss('validPosicionamiento')" name="" title="" class="form-control" id="inpDescripcion" value="">
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('validPosicionamiento','required')">
                                                Debe marcar al menos un posicionamiento
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-md-9" *ngIf="mostrarFrecuenciaReducida">
                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Frecuencia Reducida - Sanidad Vegetal</strong>
                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="frInsp"
                                         [columns]="colsFrecRed" sortField="GrupoFrDescripcion" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(frInsp)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Frecuencia' && col.field!=='PorcentajePif' && col.field!=='PorcentajeNacional')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="col.field==='Frecuencia'" [ngClass]="'cumplefr'">
                                                    {{rowData[col.field]}} %
                                                </span>

                                                <span *ngIf="col.field==='PorcentajePif'"
                                                      [ngClass]="rowData[col.field] < rowData['Frecuencia'] ? 'nocumplefr' : 'cumplefr'"
                                                      ngbTooltip="{{ rowData['TotalConFisicaPif'] }} de {{ rowData['TotalPif'] }}">
                                                    {{rowData[col.field]}} %
                                                </span>

                                                <span *ngIf="col.field==='PorcentajeNacional'" [ngClass]="rowData[col.field] < rowData['Frecuencia'] ? 'nocumplefr' : 'cumplefr'"
                                                      ngbTooltip="{{ rowData['TotalConFisicaNacional'] }} de {{ rowData['TotalNacional'] }}">
                                                    {{rowData[col.field]}} %
                                                </span>

                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>
                </div>



                <!--RESOLUCIÓN-->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> <strong>Resolución</strong>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="row">
                            <div class="form-group col-md-3 pt-4">
                                <label class="col-form-label pe-4" for="">Documental: </label>
                                <p-triStateCheckbox formControlName="Documental" label="{{labelDocumental}}" [ngClass]="displayFieldCss('Documental')" (onChange)="onChangeDocumental()"></p-triStateCheckbox>

                            </div>
                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpCodigo">Inspector Documental</label>
                                <input readonly formControlName="InspectorDocumental" name="InspectorDocumental" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFecha">Fecha Documental</label>
                                <input formControlName="FechaDocumental" name="FechaDocumental" readonly title="" class="form-control" id="inpDescripcion" value="">
                            </div>
                        </div>

                        <fieldset class="mt-2 card">

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label">Se efectúa Inspección Identidad y/o Física </label>
                                    <p-toggleButton class="form-control-togglebutton"
                                                    formControlName="SeEfectuaIdentidadFisica" onLabel="Sí" offLabel="NO"
                                                    onIcon="pi pi-check" offIcon="pi pi-times" (onChange)="onSelectedIdentidadFisica()" id=""></p-toggleButton>
                                </div>

                            </div>

                            <div class="row">
                                <div class="form-group col-md-3 pt-4">
                                    <label class="col-form-label pe-2 col-3">Identidad: </label>
                                    <p-triStateCheckbox formControlName="Identidad" label="{{labelIdentidad}}" (onChange)="onChangeIdentidad()"></p-triStateCheckbox>
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpCodigo">Inspector Identidad</label>
                                    <input readonly formControlName="InspectorIdentidad" name="InspectorIdentidad" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Identidad</label>
                                    <input formControlName="FechaIdentidad" name="FechaIdentidad" readonly title="" class="form-control" id="inpDescripcion" value="">
                                </div>

                            </div>

                            <div class="row">
                                <div class="form-group col-md-3 pt-4">
                                    <label class="col-form-label pe-3 col-3">Física: </label>
                                    <p-triStateCheckbox formControlName="Fisica" label="{{labelFisica}}" (onChange)="onChangeFisica()"></p-triStateCheckbox>
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpCodigo">Inspector Física</label>
                                    <input readonly formControlName="InspectorFisica" name="InspectorFisica" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Física</label>
                                    <input formControlName="FechaFisica" name="FechaFisica" readonly title="" class="form-control" id="inpDescripcion" value="">
                                </div>

                            </div>
                        </fieldset>


                        <!--SEGUIMIENTOS INSPECCIÓN-->
                        <div *ngIf="TComentarioInspectorExCollection != null && TComentarioInspectorExCollection.length > 0" class="card card-accent-success">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> Listado de Seguimientos de Inspección

                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearchObservaciones autoLayout="true" [value]="TComentarioInspectorExCollection"
                                         [columns]="colsObservaciones" sortField="Fecha" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm"
                                         [ngClass]="displayGridHidden(TComentarioInspectorExCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">{{rowData[col.field]}}</span>
                                                <span *ngIf="col.field==='Fecha'">{{rowData[col.field] | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                                                <div *ngIf="col.field==='Link'" class="btn-group">
                                                    <div *ngIf="checkEdit(rowData)">
                                                        <button (click)="onEditSeguimiento(rowData)" type="button" title="Editar"
                                                                class="btn btn-sm btn-warning">
                                                            <span class="fa fa-edit"></span>

                                                        </button>
                                                    </div>

                                                    <div *ngIf="!checkEdit(rowData)">
                                                        <button (click)="onEditSeguimiento(rowData)" type="button" title="Consultar"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-search"></span>

                                                        </button>
                                                    </div>

                                                    <div *ngIf="checkDelete(rowData)">
                                                        <button (click)="onDeleteSeguimiento(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>

                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="TComentarioInspectorExCollection?.length == 0" class="empty-grid">
                                    No hay seguimientos asociados a la solicitud
                                </div>
                            </div>
                        </div>

                        <!--OBSERVACIONES INSPECCIÓN-->
                        <div class="row group-filtros">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirObservaciones}" for="inpCodigo">Observaciones Resultado Inspección</label>
                                <textarea style="resize:none" formControlName="Observaciones"
                                          maxlength="5000" name="Observaciones" title="" type="text" class="form-control" inputStyleClass="form-control"
                                          value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Observaciones','required')">
                                    Observaciones es obligatorio
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--DESINFECCION-->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> <strong>Tratamiento de Desinfectación y/o Desinfección</strong>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="row">
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpDescripcion">Tratamiento</label>
                                <input formControlName="Tratamiento" name="Tratamiento" maxlength="150" title="" class="form-control" id="" type="text" value="">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpDescripcion">Producto Químico</label>
                                <input formControlName="ProductoQuimico" name="ProductoQuimico" maxlength="150" title="" class="form-control" id="" type="text" value="">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpDescripcion">Concentración</label>
                                <input formControlName="Concentracion" name="Concentracion" maxlength="50" title="" class="form-control" id="" type="text" value="">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpDescripcion">Duración</label>
                                <input formControlName="Duracion" name="Duracion" maxlength="50" title="" class="form-control" id="" type="text" value="">
                            </div>
                        </div>
                        <div class="row group-filtros">
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpDescripcion">Temperatura</label>
                                <input formControlName="Temperatura" name="Temperatura" maxlength="50" title="" class="form-control" id="" type="text" value="">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpDescripcion">Fecha</label>
                                <p-calendar formControlName="FechaDesinfeccion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpDescripcion">Información Adicional</label>
                                <input formControlName="InformacionAdicional" name="InformacionAdicional" maxlength="500" title="" class="form-control" id="" type="text" value="">
                            </div>
                        </div>
                    </div>
                </div>

                <!--DECISIÓN-->
                <div class="card card-accent-success animated fadeIn" *ngIf="visibilityDecision">
                    <a class="card-header-a">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> <strong>Decisión</strong>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="group-campos" id="">
                            <div class="row" style="flex-wrap: nowrap">

                                <div *ngIf="habilitarAceptarDecision" class="col-md-4" style="text-align:center">
                                    <p-radioButton class="radiobuttonSuccess" formControlName="IdDecision" (click)="onSelectedDecision()"
                                                   inputStyleClass="form-control" name="IdDecision" value="A" label="Aceptar"></p-radioButton>
                                </div>
                                <div *ngIf="habilitarRechazarDecision" class="col-md-4" style="text-align:center">
                                    <p-radioButton class="radiobuttonDanger" formControlName="IdDecision" (click)="onSelectedDecision()" inputStyleClass="form-control" name="IdDecision"
                                                   value="R" label="Rechazar"></p-radioButton>
                                </div>

                            </div>

                            <!--FECHA FINALIZACION-->
                            <div class="row">
                                <div *ngIf="fechaFinalizacion !== null" class="col-md-12">
                                    <hr />
                                    <h6>Fecha de la Decisión: {{fechaFinalizacion}}</h6>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <!--DESTINO CONTROLADO
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a">
                            <div class="card-header-buscador">
                                <i class="fa fa-list"></i> Destino Controlado
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">Nombre</label>
                                    <div class="input-group">
                                        <input readonly formControlName="Descripcion" name="Nombre" title="" class="form-control" [ngClass]="displayFieldCss('Descripcion')" id="" type="text" value="">
                                        <span class="input-group-btn">
                                            &nbsp;<button name="btnSearchDestinoControl" class="btn btn-list btn-secondary" type="button"
                                                          title="Buscar Destino Controlado" (click)="onSearchDestinoControl()">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </span>
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Descripcion','required')">
                                        El Destino Controlado es obligatorio debido a una de las medidas seleccionadas
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">País</label>
                                    <input readonly formControlName="IdPaisDescripcion" [ngClass]="displayFieldCss('IdPaisDescripcion')" name="IdPaisDescripcion" title="" class="form-control" id="" type="text" value="">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisDescripcion','required')">
                        País es obligatorio
                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">Código Traces</label>
                                    <input readonly formControlName="IdentificadorTraces" [ngClass]="displayFieldCss('IdentificadorTraces')" name="IdentificadorTraces" title="" class="form-control" id="" type="text" value="">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdentificadorTraces','required')">
                        Código Traces es obligatorio
                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">Localidad</label>
                                    <input readonly formControlName="Localidad" [ngClass]="displayFieldCss('Localidad')" name="Localidad" title="" class="form-control" id="" type="text" value="">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Localidad','required')">
                        Localidad es obligatorio
                    </div>
                                </div>
                                <div class="form-group col-md-9">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">Dirección</label>
                                    <input readonly formControlName="Direccion" [ngClass]="displayFieldCss('Direccion')" name="Direccion" title="" class="form-control" id="" type="text" value="">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Direccion','required')">
                        Dirección es obligatorio
                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>-->

            </div>
        </div>
    </div>

</form>
